var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.677 3.051c-.053.02-.149.069-.213.109-.065.04-1.62 1.574-3.457 3.409l-3.34 3.336L3.3 8.545C1.71 6.962 1.794 7.027 1.333 7.027c-.256 0-.293.006-.432.077a1.004 1.004 0 0 0-.462 1.342c.062.136.278.362 1.849 1.933 1.571 1.571 1.797 1.787 1.933 1.849.289.132.602.132.891 0 .139-.063.539-.454 3.934-3.849 3.394-3.395 3.786-3.795 3.849-3.933.235-.518.039-1.088-.462-1.341-.13-.066-.186-.078-.405-.084a1.053 1.053 0 0 0-.351.03m2.667 2.667a1.55 1.55 0 0 0-.214.109c-.064.04-1.095 1.048-2.29 2.241l-2.173 2.168-.206-.193a2.019 2.019 0 0 0-.36-.272c-.142-.071-.178-.078-.434-.078s-.293.007-.433.077a1.004 1.004 0 0 0-.462 1.341c.058.126.176.258.677.76.538.538.628.617.792.695.167.079.21.087.426.087s.258-.008.426-.088c.178-.084.306-.207 2.792-2.693 2.325-2.325 2.614-2.622 2.676-2.76a1.003 1.003 0 0 0-.461-1.341c-.13-.066-.186-.077-.405-.083-.169-.005-.288.005-.351.03"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCheck);
export default __webpack_public_path__ + "static/media/check-check.4cd19a7c.svg";
export { ForwardRef as ReactComponent };